import 'es6-object-assign/auto';
import $ from 'jquery';
import debounce from 'lodash/debounce';
import { historyComponentMixin } from '../../plugins/history';

import template from './subject-group-list.vhtml';
import openPopup from '../open-popup/open-popup';

export default {
	template,
	mixins: [ historyComponentMixin ],
	props: {
		postType: {
			type: String,
			default: '',
		},
		postPerPage: {
			type: Number,
			default: -1,
		},
		filters: {
			type: Object,
			default: function () {
				return {};
			},
		},
		metaQuery: {
			type: String,
			required: false,
		},
		listType: {
			type: String,
			default: 'subject-group',
		},
		listHeading: {
			type: String,
			default: null,
		},
		smartLearning: {
			type: Object,
			default: null,
		},
		isSingleSubject: {
			type: Boolean,
			default: false,
		},
		titleAsLink: {
			type: Boolean,
			default: false,
		},
		isPopupActive: {
			type: Boolean,
			'default': false,
		},
		urlParamName: {
			type: String,
			default: 'sign-up',
		},
	},
	data() {
		return {
			rows: [],
			page: 1,
			isLoading: false,
			isFetching: false,
			loadMore: false,
			loadedOnce: false,
		};
	},
	computed: {
		hasLoaded() {
			return this.loadedOnce && this.rows.length === 0;
		},
		urlParam() {
			return this.history.queryParams[this.urlParamName];
		},
	},
	watch: {
		filters: function() {
			this.page = 1;
			this.reload();
		},
		isPopupActive() {
			if ( this.isPopupActive === false ) {
				this.history.setQueryParam( this.urlParamName, null );
			}
		},
	},
	methods: {
		fetchMore: function() {
			this.page++;
			this.isFetching = true;
			getItems(this.postType, this.filters, this.metaQuery, '', this.postPerPage, this.page )
			.then( items => {
				if ( items ) {
					this.loadMore = this.postPerPage === items.length;
					this.rows = this.rows.concat( items );
				}
			})
			.always( () => this.isFetching = false );
		},
		reload: debounce( function() {
			this.isLoading = true;
			getItems(this.postType, this.filters, this.metaQuery, '', this.postPerPage, this.page )
				.then( items => {
					if ( items ) {
						this.loadMore = this.postPerPage === items.length;
						this.rows = items;
					}
				})
				.always( () => { 
					this.isLoading = false;
					this.loadedOnce = true; 
				});
		}, 500 ),
		openPopup( value ) {
			let popupData = {
				type: '.js-subject-group-sign-up',
				data: value,
			};
			const group = encodeURI( popupData.data.Group.toLowerCase() );
			this.history.setQueryParam( this.urlParamName, group );
			this.$emit( 'update-popup', popupData );
		},
	},
	created() {
		this.reload();
	},
	mounted() {
		if ( this.urlParam ) {
			let subjectGroup = [];

			getItems( this.postType, this.filters, this.metaQuery, this.urlParam.toUpperCase(), this.postPerPage, this.page )
				.then(items => {
					if ( items ) {
						subjectGroup = items[0];
						if ( subjectGroup !== undefined ) {
							this.openPopup( subjectGroup );
						}
					}
				});
		}
	},
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getItems( postType = '', filters, metaQuery, groupId, postPerPage, page ) {
	const params = {
		'post_type': postType,
		'posts_per_page': postPerPage,
		'page': page,
		'easv_education_subject_areas': filters.easv_education_subject_areas,
		'easv_location_tag': filters.easv_location_tag,
		'easv_education_language': filters.easv_education_language,
		'easv_education_level': filters.easv_education_level,
		'easv_education_economy': filters.easv_education_economy,
		'easv_education_duration': filters.easv_education_duration,
		'meta_query': metaQuery,
		'search_str': filters.search_str,
		'lang': window.siteData.language,
		'group_id': groupId,
	};

	return $.get( `/wp-json/easv/v1/subject-groups`, params );
}



// WEBPACK FOOTER //
// ./assets/_js/components/subject-group-list/subject-group-list.js